import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Moon, Volume2 } from "lucide-react";

const TypeLine = ({ text, delay }) => {
  const [shown, setShown] = useState("");
  useEffect(() => {
    let i = 0;
    const t = setTimeout(() => {
      const iv = setInterval(() => {
        i++;
        setShown(text.slice(0, i));
        if (i >= text.length) clearInterval(iv);
      }, 12);
      return () => clearInterval(iv);
    }, delay);
    return () => clearTimeout(t);
  }, [text, delay]);
  return <span>{shown}</span>;
};

export function SleepReport({ open, onOpenChange, report, onNarrate }) {
  if (!report) return null;
  const rows = [
    ["compressed", report.compressed],
    ["replayed", report.replayed],
    ["pruned", report.pruned],
    ["promoted", report.promoted],
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-black border border-[#1E222A] max-w-lg p-0 overflow-hidden" data-testid="sleep-report-modal">
        <div className="scanlines">
          <DialogHeader className="p-5 border-b border-[#1E222A]">
            <DialogTitle className="font-mono2 text-[#FFB340] flex items-center gap-2 text-sm tracking-widest uppercase">
              <Moon className="w-4 h-4" /> Sleep / Replay Cycle #{report.cycle}
            </DialogTitle>
            <DialogDescription className="sr-only">
              OCTON's nightly HNHB consolidation report - what it compressed, replayed, pruned and reassessed.
            </DialogDescription>
          </DialogHeader>
          <div className="p-5 font-mono2 text-sm text-[#FFB340] space-y-3 max-h-[60vh] overflow-y-auto">
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="leading-relaxed text-[#FFCF80]">
              <TypeLine text={report.narration} delay={150} />
            </motion.p>
            <div className="pt-3 border-t border-[#241d0f] space-y-2">
              {rows.map(([k, arr]) => (
                <div key={k} className="flex gap-3">
                  <span className="text-[#7a5e2a] uppercase w-24 shrink-0">{k}</span>
                  <span className="text-[#FFB340]">
                    {arr && arr.length ? arr.join(", ") : "\u2014"}
                  </span>
                </div>
              ))}
              <div className="flex gap-3">
                <span className="text-[#7a5e2a] uppercase w-24 shrink-0">pred_error</span>
                <span>{report.prediction_error}</span>
              </div>
            </div>
            {onNarrate && (
              <button data-testid="narrate-sleep-btn" onClick={onNarrate}
                className="mt-2 inline-flex items-center gap-2 text-xs text-black bg-[#FFB340] px-3 py-1.5 rounded-full hover:bg-[#ffc35f] transition-colors">
                <Volume2 className="w-3.5 h-3.5" /> Hear OCTON narrate
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
